module.exports = __webpack_public_path__ + "static/media/how_it_works.4a122192.png";